import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const TransportSettingsComponent = ({ selectTransportSettings, handleInnerFormChange, transporters }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Transporter Name"
                            labelField="Name"
                            list={transporters}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransportSetting.TransporterId'
                                );
                            }}
                            optionName='Choose Transporter'
                            type="select"
                            value={selectTransportSettings?.TransportSetting?.TransporterId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="From Distance"
                            name="FromDistance"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransportSetting.FromDistance',
                                    selectTransportSettings?.TransportSetting
                                )
                            }}
                            type="number"
                            value={selectTransportSettings?.TransportSetting?.FromDistance}
                        />
                        <InputContainer
                            label="To Distance"
                            name="ToDistance"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransportSetting.ToDistance',
                                    selectTransportSettings?.TransportSetting
                                )
                            }}
                            type="number"
                            value={selectTransportSettings?.TransportSetting?.ToDistance}
                        />
                        <InputContainer
                            label="Tranport Amount"
                            name="TranportAmount"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransportSetting.TranportAmount',
                                    selectTransportSettings?.TransportSetting
                                )
                            }}
                            type="text"
                            value={selectTransportSettings?.TransportSetting?.TranportAmount}
                        />
                    </div>
                }
                expandedPanel="Transport Settings"
                headerTitle="Transport Settings"
            />
        </>
    )
}
export default TransportSettingsComponent;
